import * as React from "react";

import { DateInput, DateInputProps } from "@progress/kendo-react-dateinputs";
import { enMessages } from "../../../messages/en-US";
import { useLocalization } from "@progress/kendo-react-intl";

const CustomStartDateInput = (props: DateInputProps) => {
  const localizationService = useLocalization();

  return (
    <div style={{ display: "flex"}}>
        <DateInput {...props} label={localizationService.toLanguageString('custom.startDate', enMessages.custom.startDate)} />
        <p className="pt-4">&nbsp;&nbsp;-</p>
    </div>
  );
};

export default CustomStartDateInput;